const SEVERITY_RANK = {
  low: 0,
  medium: 1,
  high: 2,
  critical: 3,
};

export function normalizeSeverity(severity) {
  const key = String(severity || "medium").toLowerCase();
  return SEVERITY_RANK[key] !== undefined ? key : "medium";
}

export function severityRank(severity) {
  return SEVERITY_RANK[normalizeSeverity(severity)] ?? 1;
}

export function maxSeverityFromAlerts(alerts = []) {
  let best = null;
  let bestRank = -1;

  for (const alert of alerts) {
    const key = normalizeSeverity(alert?.severity);
    const rank = severityRank(key);
    if (rank > bestRank) {
      bestRank = rank;
      best = key;
    }
  }

  return best;
}

export function isHighRiskSeverity(severity) {
  const key = normalizeSeverity(severity);
  return key === "high" || key === "critical";
}
